import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import clinicService from '../../../../../services/clinic.service';
import AddressForm from './AddressForm';
import Loading from '../../../../common/Loading';

const AddressCard = () => {
    const {clinicId} = useParams()
    const [isEditing, setIsEditing] = useState(false)
    const [address, setAddress] = useState({
        street: "90 Sheppard Ave East",
        city: "Toronto",
        postalCode: "M1P 1A1",
        country: "Canada",
        province: "ON"
    })
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {

        setIsLoading(true)
        clinicService.getAddress(clinicId)
            .then(res => {
                setAddress(res.data)
                setIsLoading(false)

            })
            .catch(error => {
                if (error.response?.status === 404) {
                    setAddress({
                        street: "",
                        city: "",
                        postalCode: "",
                        country: "",
                        province: ""
                    })
                    setIsLoading(false)
                    setIsEditing(true)

                } else {

                    setIsLoading(false)
                }
            })
    }, [clinicId])

    const updateAddress = (add) => {
        setAddress(add)

    }
    const updateEditing = () => {
        setIsEditing(!isEditing)
    }
    return (
        <div className="card card-padding shadow-none card-border border-light">
            <div className="card-title">
                <div className="d-flex justify-content-between align-items-center">
                    <div><i className='bi bi-geo-alt'></i> Address</div>
                    <button
                        className={`btn btn-sm ${isEditing ? 'btn-outline-danger' : 'btn-outline-primary'}`}
                        onClick={() => setIsEditing(!isEditing)}
                    >
                        <i className={`bi ${isEditing ? 'bi-x' : 'bi-pencil-square'}`}></i> {isEditing ? 'Cancel' : 'Edit'}
                    </button>
                </div>
            </div>
            <div>
                {isLoading ? <Loading/> :
                    !isEditing ?
                        address.street + ", " + address.city + ", " + address.province + " " + address.postalCode + ", " + address.country
                        :
                        <AddressForm address={address} updateAddress={updateAddress} updateEditing={updateEditing}/>
                }
            </div>
        </div>
    );
}

export default AddressCard;